import * as actionTypes from "./actionTypes";

export const registerDevice = (data) => {
  return {
    type: actionTypes.REGISTER_DEVICE,
    data,
  };
};

export const registerDeviceSuccess = (data, uuid) => {
  return {
    type: actionTypes.REGISTER_DEVICE_SUCCESS,
    data,
    uuid,
  };
};

export const registerDeviceFail = () => {
  return {
    type: actionTypes.REGISTER_DEVICE_FAIL,
  };
};

export const consumerLogin = (data) => {
  return {
    type: actionTypes.CONSUMER_LOGIN,
    data,
  };
};

export const consumerLoginSuccess = (token, data) => {
  return {
    type: actionTypes.CONSUMER_LOGIN_SUCCESS,
    token,
    data,
  };
};
export const consumerLoginFail = (data) => {
  return {
    type: actionTypes.CONSUMER_LOGIN_FAIL,
    data,
  };
};

export const consumerLogout = () => {
  return {
    type: actionTypes.CONSUMER_LOGOUT,
  };
};

export const consumerLogoutSuccess = () => {
  return {
    type: actionTypes.CONSUMER_LOGOUT_SUCCESS,
  };
};

export const consumerLogoutFail = () => {
  return {
    type: actionTypes.CONSUMER_LOGOUT_FAIL,
  };
};

// Relogin
export const consumerRelogin = (data) => {
  return {
    type: actionTypes.CONSUMER_RELOGIN,
    data,
  };
};

export const consumerReloginSuccess = (data) => {
  return {
    type: actionTypes.CONSUMER_RELOGIN_SUCCESS,
    data,
  };
};

export const consumerReloginFail = () => {
  return {
    type: actionTypes.CONSUMER_RELOGIN_FAIL,
  };
};
// END Relogin

// Force logout
export const consumerForceLogout = (data) => {
  return {
    type: actionTypes.CONSUMER_FORCE_LOGOUT,
    data,
  };
};

export const consumerForceLogoutSuccess = () => {
  return {
    type: actionTypes.CONSUMER_FORCE_LOGOUT_SUCCESS,
  };
};
// END Force logout

// Redirect Last Path
export const consumerRedirectLastPath = () => {
  return {
    type: actionTypes.CONSUMER_REDIRECT_LAST_PATH,
  };
};
// END Redirect Last Path

export const sendSMS = (data) => {
  return {
    type: actionTypes.SEND_SMS,
    data,
  };
};

export const sendSMSSuccess = () => {
  return {
    type: actionTypes.SEND_SMS_SUCCESS,
  };
};

export const sendSMSFail = () => {
  return {
    type: actionTypes.SEND_SMS_FAIL,
  };
};

export const verifySMS = (data) => {
  return {
    type: actionTypes.VERIFY_SMS,
    data,
  };
};

export const verifySMSSuccess = () => {
  return {
    type: actionTypes.VERIFY_SMS_SUCCESS,
  };
};

export const verifySMSFail = () => {
  return {
    type: actionTypes.VERIFY_SMS_FAIL,
  };
};

export const resetPassword = (data) => {
  return {
    type: actionTypes.RESET_PASSWORD,
    data,
  };
};

export const resetPasswordSuccess = () => {
  return {
    type: actionTypes.RESET_PASSWORD_SUCCESS,
  };
};

export const resetPasswordFail = () => {
  return {
    type: actionTypes.RESET_PASSWORD_FAIL,
  };
};

export const consumerSignUp = (data) => {
  return {
    type: actionTypes.CONSUMER_SIGN_UP,
    data,
  };
};

export const consumerSignUpSuccess = () => {
  return {
    type: actionTypes.CONSUMER_SIGN_UP_SUCCESS,
  };
};

export const consumerSignUpFail = () => {
  return {
    type: actionTypes.CONSUMER_SIGN_UP_FAIL,
  };
};

export const getConsumerProfileDetails = () => {
  return {
    type: actionTypes.GET_CONSUMER_PROFILE_DETAILS,
  };
};

export const getConsumerProfileDetailsSuccess = (data) => {
  return {
    type: actionTypes.GET_CONSUMER_PROFILE_DETAILS_SUCCESS,
    data,
  };
};

export const getConsumerProfileDetailsFail = () => {
  return {
    type: actionTypes.GET_CONSUMER_PROFILE_DETAILS_FAIL,
  };
};
